import COLORS from '~/lib/helpers/color-helper';

export default function SaveMoneySVG(props: {
  marginLeft?: string;
  marginRight?: string;
  marginTop?: string;
  marginBottom?: string;
}) {
  return (
    <svg
      width='125'
      height='125'
      viewBox='0 0 125 125'
      fill='none'
      style={{
        marginLeft: props.marginLeft,
        marginRight: props.marginRight,
        marginTop: props.marginTop,
        marginBottom: props.marginBottom,
      }}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.2323 51.21C10.2323 74.2706 28.9267 92.9649 51.9873 92.9649C75.0479 92.9649 93.7422 74.2706 93.7422 51.21C93.7422 28.1493 75.0479 9.45502 51.9873 9.45502C28.9267 9.45502 10.2323 28.1493 10.2323 51.21Z'
        fill='#FFF2D9'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M90.4904 67.3916L65.6164 57.1833L49.4105 95.4026L74.2845 105.611L90.4904 67.3916Z'
        fill='#FFCD69'
      />
      <mask
        id='mask0_93_1480'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='4'
        y='80'
        width='84'
        height='37'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.84238 80.5793H87.3587V116.087H4.84238V80.5793Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask0_93_1480)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M81.0206 103.785L87.3587 80.5793L4.84238 80.5864L11.1783 103.785C13.1623 111.048 19.7608 116.087 27.2902 116.087H64.9087C72.4381 116.087 79.0366 111.048 81.0206 103.785Z'
          fill='#C5E79F'
        />
      </g>
      <path d='M9.29559 96.8955L82.9041 96.8859' stroke='#081F2D' strokeWidth='0.501088' />
      <path d='M32.7902 116.087L32.7949 80.5793' stroke='#081F2D' strokeWidth='0.501088' />
      <path d='M60.4356 116.087L60.4403 80.5817' stroke='#081F2D' strokeWidth='0.501088' />
      <path
        d='M32.7947 80.5792C32.7947 72.9452 38.9833 66.7567 46.6172 66.7567C54.2514 66.7567 60.44 72.9452 60.44 80.5792'
        stroke='#081F2D'
        strokeWidth='0.501088'
      />
      <mask
        id='mask1_93_1480'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='66'
        y='0'
        width='56'
        height='56'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M66.4233 0.913391H121.061V55.5504H66.4233V0.913391Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask1_93_1480)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M76.5832 45.3909C77.6706 46.4782 77.6706 48.2402 76.5832 49.3275C75.4967 50.4141 73.734 50.4148 72.6467 49.3275C71.5593 48.2404 71.5601 46.4775 72.6467 45.3909C73.734 44.3036 75.4959 44.3036 76.5832 45.3909ZM66.5313 35.3276L69.1556 48.4504C69.5964 50.6549 71.3192 52.3777 73.5229 52.8177L86.6454 55.4418C88.4706 55.8073 90.3578 55.2365 91.6743 53.9201L121.061 24.5333L97.4407 0.913025L68.054 30.2998C66.7375 31.6162 66.1668 33.5034 66.5313 35.3276Z'
          fill='#BCA5F6'
        />
      </g>
      <path d='M85.5913 29.0364L102.784 26.2976' stroke='#643AB7' strokeWidth='0.835065' strokeLinejoin='round' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M93.5415 31.6106C94.7339 30.4182 96.6669 30.4177 97.8588 31.6096C99.0505 32.8013 99.05 34.7343 97.8576 35.9267C96.6652 37.1192 94.7322 37.1196 93.5405 35.928C92.3486 34.736 92.3491 32.803 93.5415 31.6106Z'
        stroke='#643AB7'
        strokeWidth='0.835065'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M90.6372 19.527C91.8297 18.3346 93.7626 18.3341 94.9546 19.526C96.1463 20.7177 96.1458 22.6507 94.9533 23.8431C93.7609 25.0355 91.8279 25.036 90.6363 23.8443C89.4443 22.6524 89.4448 20.7194 90.6372 19.527Z'
        stroke='#643AB7'
        strokeWidth='0.835065'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M26.4742 46.0865C24.8425 46.655 19.7305 48.3581 14.7644 46.6462C13.9342 46.3602 11.972 45.6615 11.8942 44.5567C11.7985 43.2006 14.5734 41.9397 15.7075 41.512C19.3539 40.1362 31.4041 37.5439 47.8443 34.7726C43.5127 37.776 35.4328 42.9643 26.4742 46.0865Z'
        fill='#081F2D'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M26.4742 46.0865C24.8425 46.655 19.7305 48.3581 14.7644 46.6462C13.9342 46.3602 11.972 45.6615 11.8942 44.5567C11.7985 43.2006 14.5734 41.9397 15.7075 41.512C19.3539 40.1362 31.4041 37.5439 47.8443 34.7726C43.5127 37.776 35.4328 42.9643 26.4742 46.0865Z'
        stroke='#081F2D'
        strokeWidth='0.501088'
        stroke-linecap='round'
        strokeLinejoin='round'
      />
      <mask
        id='mask2_93_1480'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='20'
        y='34'
        width='49'
        height='47'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M20.2248 40.0354C22.8235 46.7486 23.9175 52.3152 24.4397 56.1196C25.186 61.5356 25.197 66.516 28.3662 72.4254C31.2593 77.8264 33.4679 77.8084 33.908 77.7809C35.0765 77.7073 35.8895 76.8299 36.2722 76.4201C36.661 75.9995 36.9832 75.5156 37.2379 74.9821C37.8731 77.4368 39.0309 79.4985 40.6719 80.1431C41.3645 80.4182 42.663 80.6442 43.9716 80.149C45.8115 79.4618 46.6094 77.7523 46.8113 77.2916C47.7502 78.6713 48.8589 79.6393 50.0427 79.8596C50.9605 80.0291 51.7311 79.719 51.8487 79.6693C54.6628 78.486 54.6527 73.4242 54.6448 73.006C56.3802 74.9129 58.6127 76.113 60.6795 75.7669C62.0506 75.5395 63.136 74.6661 63.94 73.7052C65.0621 73.8111 65.9808 73.2443 66.0584 73.1963C69.625 70.8264 67.9394 61.5509 66.2749 56.4352C65.5115 54.0917 63.2192 47.3235 56.9942 41.6452C53.0414 38.0374 50.9716 38.0364 47.1009 34.0267L20.2248 40.0354Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask2_93_1480)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M20.2248 40.0354C22.8235 46.7486 23.9175 52.3152 24.4397 56.1196C25.186 61.5356 25.197 66.516 28.3662 72.4254C31.2593 77.8264 33.4679 77.8084 33.908 77.7809C35.0765 77.7073 35.8895 76.8299 36.2722 76.4201C36.661 75.9995 36.9832 75.5156 37.2379 74.9821C37.8731 77.4368 39.0309 79.4985 40.6719 80.1431C41.3645 80.4182 42.663 80.6442 43.9716 80.149C45.8115 79.4618 46.6094 77.7523 46.8113 77.2916C47.7502 78.6713 48.8589 79.6393 50.0427 79.8596C50.9605 80.0291 51.7311 79.719 51.8487 79.6693C54.6628 78.486 54.6527 73.4242 54.6448 73.006C56.3802 74.9129 58.6127 76.113 60.6795 75.7669C62.0506 75.5395 63.136 74.6661 63.94 73.7052C65.0621 73.8111 65.9808 73.2443 66.0584 73.1963C69.625 70.8264 67.9394 61.5509 66.2749 56.4352C65.5115 54.0917 63.2192 47.3235 56.9942 41.6452C53.0414 38.0374 50.9716 38.0364 47.1009 34.0267L20.2248 40.0354Z'
          fill='url(#paint0_linear_93_1480)'
        />
      </g>
      <path
        d='M36.7447 47.3284C37.5352 48.4556 38.9075 50.1001 41.0642 51.4801C44.4791 53.6648 47.8602 53.9063 49.3903 53.9186'
        stroke='#081F2D'
        strokeWidth='0.501088'
      />
      <mask
        id='mask3_93_1480'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='29'
        y='63'
        width='10'
        height='15'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M32.9255 64.0987C30.6563 64.7698 29.9916 68.1015 29.7548 69.2887C29.5203 70.4647 28.8843 73.6523 30.787 76.005C31.1043 76.3975 32.2999 77.8759 33.9073 77.7812C35.1258 77.7095 35.9505 76.7637 36.2687 76.4201C39.3557 73.089 38.2293 65.6571 35.0564 64.2419C34.9766 64.2062 34.4509 63.9803 33.7603 63.9803C33.5004 63.9803 33.2172 64.0123 32.9255 64.0987Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask3_93_1480)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M32.9255 64.0987C30.6563 64.7698 29.9916 68.1015 29.7548 69.2887C29.5203 70.4647 28.8843 73.6523 30.787 76.005C31.1043 76.3975 32.2999 77.8759 33.9073 77.7812C35.1258 77.7095 35.9505 76.7637 36.2687 76.4201C39.3557 73.089 38.2293 65.6571 35.0564 64.2419C34.9766 64.2062 34.4509 63.9803 33.7603 63.9803C33.5004 63.9803 33.2172 64.0123 32.9255 64.0987Z'
          fill='url(#paint1_linear_93_1480)'
        />
      </g>
      <mask
        id='mask4_93_1480'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='36'
        y='63'
        width='12'
        height='18'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M38.9193 63.9264C35.2995 65.836 36.1469 78.3603 40.6727 80.1444C41.4076 80.434 42.7142 80.6275 43.9728 80.1517C45.7414 79.4833 46.5521 77.8196 46.8088 77.2921C48.7641 73.2783 46.0847 68.609 44.294 65.4885C44.133 65.2079 43.8411 64.7236 43.2832 64.3133C42.5414 63.7674 41.5916 63.5452 40.7214 63.5452C40.0185 63.5452 39.3675 63.6902 38.9193 63.9264Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask4_93_1480)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M38.9193 63.9264C35.2995 65.836 36.1469 78.3603 40.6727 80.1444C41.4076 80.434 42.7142 80.6275 43.9728 80.1517C45.7414 79.4833 46.5521 77.8196 46.8088 77.2921C48.7641 73.2783 46.0847 68.609 44.294 65.4885C44.133 65.2079 43.8411 64.7236 43.2832 64.3133C42.5414 63.7674 41.5916 63.5452 40.7214 63.5452C40.0185 63.5452 39.3675 63.6902 38.9193 63.9264Z'
          fill='url(#paint2_linear_93_1480)'
        />
      </g>
      <mask
        id='mask5_93_1480'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='44'
        y='62'
        width='11'
        height='18'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M45.5219 63.2147C41.8897 66.6196 45.3958 78.996 50.0415 79.862C50.2285 79.8967 51.0136 80.0242 51.848 79.6703C54.4484 78.5665 54.6084 74.0203 54.6443 73.0053C54.6569 72.644 54.7474 68.2213 51.6718 64.5346C50.8244 63.5186 49.6731 62.178 48.0544 62.1578C48.0421 62.1576 48.0295 62.1576 48.0175 62.1576C46.6892 62.1576 45.6993 63.0483 45.5219 63.2147Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask5_93_1480)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M45.5219 63.2147C41.8897 66.6196 45.3958 78.996 50.0415 79.862C50.2285 79.8967 51.0136 80.0242 51.848 79.6703C54.4484 78.5665 54.6084 74.0203 54.6443 73.0053C54.6569 72.644 54.7474 68.2213 51.6718 64.5346C50.8244 63.5186 49.6731 62.178 48.0544 62.1578C48.0421 62.1576 48.0295 62.1576 48.0175 62.1576C46.6892 62.1576 45.6993 63.0483 45.5219 63.2147Z'
          fill='url(#paint3_linear_93_1480)'
        />
      </g>
      <mask
        id='mask6_93_1480'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='51'
        y='60'
        width='13'
        height='16'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M53.8095 60.7875C51.7242 61.8426 51.6088 64.983 51.5901 65.4902C51.404 70.5525 56.3927 76.4831 60.6788 75.7674C61.1127 75.6948 61.5178 75.5578 61.8949 75.3739C62.4639 75.0965 62.9682 74.7126 63.4087 74.2824L61.964 68.5386C61.9746 67.9437 61.9798 64.3989 59.2723 62.1687C59.0313 61.97 57.1505 60.4609 55.2308 60.4606C54.7512 60.4606 54.269 60.5549 53.8095 60.7875Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask6_93_1480)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M53.8095 60.7875C51.7242 61.8426 51.6088 64.983 51.5901 65.4902C51.404 70.5525 56.3927 76.4831 60.6788 75.7674C61.1127 75.6948 61.5178 75.5578 61.8949 75.3739C62.4639 75.0965 62.9682 74.7126 63.4087 74.2824L61.964 68.5386C61.9746 67.9437 61.9798 64.3989 59.2723 62.1687C59.0313 61.97 57.1505 60.4609 55.2308 60.4606C54.7512 60.4606 54.269 60.5549 53.8095 60.7875Z'
          fill='url(#paint4_linear_93_1480)'
        />
      </g>
      <path
        d='M29.7547 69.2857C29.9895 66.6206 31.2126 64.5894 32.9256 64.0954C33.0661 64.0548 34.0452 63.7878 35.0565 64.2389C35.9245 64.6261 36.6395 65.4636 37.1568 66.5443'
        stroke='#081F2D'
        strokeWidth='0.501088'
      />
      <path
        d='M44.2937 65.4856C44.1 65.1356 43.7859 64.6849 43.2831 64.3101C41.9054 63.2838 39.8917 63.4103 38.9193 63.9232C36.34 65.284 36.0287 72.0327 37.6995 76.4462'
        stroke='#081F2D'
        strokeWidth='0.501088'
      />
      <path
        d='M51.6719 64.5316C51.472 64.2183 50.1208 62.1647 48.0545 62.1549C46.7294 62.1485 45.7627 62.9857 45.5217 63.2117C42.4785 66.0646 44.4469 75.2164 47.8979 78.6179'
        stroke='#081F2D'
        strokeWidth='0.501088'
      />
      <path
        d='M57.8828 61.2383C56.7723 60.6348 55.1891 60.0864 53.8094 60.7844C51.724 61.8395 51.6086 64.9802 51.5901 65.4874C51.4705 68.7391 53.4862 72.3491 56.0793 74.3256'
        stroke='#081F2D'
        strokeWidth='0.501088'
      />
      <mask
        id='mask7_93_1480'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='47'
        y='34'
        width='22'
        height='40'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M51.6175 51.7874C53.2283 52.827 55.4554 54.6091 56.8437 57.468C58.1691 60.1971 57.5092 61.3927 58.9561 66.1349C59.965 69.4402 61.1505 73.1693 63.6385 73.6672C64.8899 73.9177 65.9733 73.2522 66.058 73.1961C69.6249 70.8275 67.9398 61.5525 66.2738 56.438C65.5099 54.0925 63.2166 47.3261 56.9951 41.648C53.0391 38.0375 50.97 38.039 47.1011 34.03L51.6175 51.7874Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask7_93_1480)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M51.6175 51.7874C53.2283 52.827 55.4554 54.6091 56.8437 57.468C58.1691 60.1971 57.5092 61.3927 58.9561 66.1349C59.965 69.4402 61.1505 73.1693 63.6385 73.6672C64.8899 73.9177 65.9733 73.2522 66.058 73.1961C69.6249 70.8275 67.9398 61.5525 66.2738 56.438C65.5099 54.0925 63.2166 47.3261 56.9951 41.648C53.0391 38.0375 50.97 38.039 47.1011 34.03L51.6175 51.7874Z'
          fill='url(#paint5_linear_93_1480)'
        />
      </g>
      <path
        d='M51.6174 51.7843C53.2284 52.8239 55.4553 54.6057 56.8436 57.4648C58.1689 60.194 57.5091 61.3896 58.9562 66.132C59.9648 69.4373 61.1503 73.1662 63.6383 73.664C64.8898 73.9146 65.9732 73.2491 66.0581 73.1927'
        stroke='#081F2D'
        strokeWidth='0.501088'
      />
      <mask
        id='mask8_93_1480'
        style={{ maskType: 'luminance' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='11'
        width='48'
        height='34'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M0.939178 11.5846H47.8432V44.8791H0.939178V11.5846Z'
          fill='white'
        />
      </mask>
      <g mask='url(#mask8_93_1480)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M38.7869 11.5846L0.939026 24.1145C4.87242 30.9399 7.30526 35.8539 8.97735 39.0656C9.99085 41.0109 10.9881 42.9486 11.9689 44.8791C11.9639 44.8641 11.9492 44.8193 11.9371 44.7711C11.9231 44.7322 11.9155 44.6928 11.9076 44.6534C11.9005 44.6199 11.896 44.5833 11.8958 44.5552C11.7988 43.2026 14.5718 41.9405 15.7076 41.512C19.3528 40.136 31.402 37.5429 47.8432 34.771L38.7869 11.5846Z'
          fill='#3B61EB'
        />
      </g>
      <path
        d='M9.25821 39.6049V39.6049C11.1594 37.1234 13.847 35.361 16.8809 34.6064L45.0429 27.6017'
        stroke='#081F2D'
        strokeWidth='0.501088'
      />
      <path
        d='M14.7643 46.6463C13.9342 46.3601 11.9719 45.6616 11.8941 44.5568C11.7984 43.2007 14.5733 41.9399 15.7074 41.5119C19.3536 40.1363 31.4041 37.5438 47.8442 34.7725'
        stroke='#081F2D'
        strokeWidth='0.501088'
        stroke-linecap='round'
        strokeLinejoin='round'
      />
      <defs>
        <linearGradient
          id='paint0_linear_93_1480'
          x1='-22.4889'
          y1='-1.98358'
          x2='1.14767'
          y2='92.1254'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF5607' />
          <stop offset='1' stopColor='#FFA700' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_93_1480'
          x1='19.3408'
          y1='53.7142'
          x2='33.8946'
          y2='74.93'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF5607' />
          <stop offset='1' stopColor='#FFA700' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_93_1480'
          x1='27.187'
          y1='53.4824'
          x2='41.0102'
          y2='74.6762'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF5607' />
          <stop offset='1' stopColor='#FFA700' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_93_1480'
          x1='35.4086'
          y1='53.2821'
          x2='50.2722'
          y2='73.1676'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF5607' />
          <stop offset='1' stopColor='#FFA700' />
        </linearGradient>
        <linearGradient
          id='paint4_linear_93_1480'
          x1='39.4984'
          y1='49.4193'
          x2='51.7574'
          y2='76.5085'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF5607' />
          <stop offset='1' stopColor='#FFA700' />
        </linearGradient>
        <linearGradient
          id='paint5_linear_93_1480'
          x1='29.0789'
          y1='18.2467'
          x2='67.2547'
          y2='58.3693'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF5607' />
          <stop offset='1' stopColor='#FFA700' />
        </linearGradient>
      </defs>
    </svg>
  );
}
